'use strict';

exports.__esModule = true;
exports.CONTACT_REQUEST = exports.CLOSE = exports.OPEN = undefined;

var _doctifyUtils = require('doctify-utils');

var OPEN = exports.OPEN = 'TELEPHONE_MODAL_ACTIONS:OPEN'; // This is an example of the actions for a component that the page will compose.
// It should export string constants for its action types (with a prefix e.g. SEARCH_BAR:GET_LOCATIONS)
// and use those in the action methods (e.g. getLocationAutocomplete).

// Things with API calls will use createAction as commented out below. See doctify/home-page.

var CLOSE = exports.CLOSE = 'TELEPHONE_MODAL_ACTIONS:CLOSE';
var CONTACT_REQUEST = exports.CONTACT_REQUEST = 'TELEPHONE_MODAL_ACTIONS:CONTACT_REQUEST';

var TelephoneModalModalActions = {
	openModal: function openModal() {
		return {
			type: OPEN
		};
	},
	closeModal: function closeModal() {
		return {
			type: CLOSE
		};
	},
	makeContactRequest: function makeContactRequest(data) {
		return (0, _doctifyUtils.createAction)({
			actionType: CONTACT_REQUEST,
			url: '/specialists/' + data.id + '/contact_request',
			method: 'POST',
			data: data
		});
	}
};

exports.default = TelephoneModalModalActions;


// WEBPACK FOOTER //
// ./components/specialist-page/lib/actions/telephone-modal.js